<div class="filters">
  <div class="model-companies" *ngIf="showModelOnlyComp">
    <span style="vertical-align: middle; margin-right: 3px"
      >Include Model-Only Companies</span
    >
    <nz-switch
      [(ngModel)]="modelCompanyValue"
      nzSize="small"
      (ngModelChange)="modelCompanyChange($event)"
    ></nz-switch>
  </div>
  <div class="show-filter">
    <span style="vertical-align: middle; margin-right: 3px; color: #000000A6">Show Filter</span>
    <nz-switch
      [(ngModel)]="showFilterValue"
      nzSize="small"
      (ngModelChange)="toggleFilter($event)"
    ></nz-switch>
  </div>
  <div id="searchDiv" style="white-space: nowrap;" *ngIf="isSearchFilter">
    <span>
      <nz-input-group [nzPrefix]="iconSearch" [nzSuffix]="inputClearTpl" class="search-input">
        <input
          style="height: 22px;"
          id="search"
          nz-input
          [(ngModel)]="searchValue"
          autocomplete="off"
          placeholder="Search by company name, ticker, and more"
          #search
          (keyup.enter)="onSearch()"
          allowClear
        />
      </nz-input-group>
      <ng-template #iconSearch>
          <va-icon
            size="small"
            name="search"
            class="searchplace"
            style="padding-right:10px"
          ></va-icon>
      </ng-template>
      <ng-template #inputClearTpl>
        <va-icon
          size="small"
          name="close-circle"
          *ngIf="searchValue"
          (click)="clearSearch()"
          class="va-close-icon"
        ></va-icon>
      </ng-template>
    </span>
  </div>
  <div
    data-feature="EXPORT_ONFILTER,BROKER_PAGE"
    class="export"
    (click)="exportToExcel()"
    *ngIf="showExport"
  >
    <button class="export-btn">
      <va-icon size="small" name="file-excel" class="export-icon"></va-icon>Export
    </button>
  </div>
  <div class="reload" title="Reload Grid" (click)="onReload()">
    <va-icon size="small" name="sync" class="reload-icon"></va-icon>
  </div>
</div>
